import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/inflation-adjusted-dollar',
  component: () => import('../../routes/InflationAdjustedDollar.svelte'),
  card: {
    id: 'inflation-adjusted-dollar',
    title: 'Inflation-Adjusted Dollar',
    description: 'See how inflation erodes your purchasing power over time and what your future dollars will actually be worth in today\'s terms.',
    icon: 'account_balance_wallet',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/inflation-adjusted-dollar',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Inflation-Adjusted Dollar Calculator – Future Purchasing Power Calculator',
    description: 'Free inflation-adjusted dollar calculator to see what future prices will cost in today\'s dollars. Calculate purchasing power erosion and understand the real value of your money over time.',
  },
};

export default meta;
